import logger from "./logger";

const removeEmptyKeys = (input) => {
  if (!!input?.removeSpace) {
    const temp = input.removeSpace;
    delete input.removeSpace;
    if (temp) {
      return input;
    }
  }
  try {
    if (Array.isArray(input)) {
      // Clean each item in the array
      return input
        .map(removeEmptyKeys)
        .filter((item) =>
          typeof item === "object"
            ? Object.keys(item).length > 0
            : item !== undefined && item !== null
        );
    }
  } catch (error) {
    logger.log(error);
  }

  try {
    if (typeof input === "object" && input !== null) {
      // If object has removeSpace flag
      if ("removeSpace" in input) {
        const { removeSpace, ...rest } = input;
        if (removeSpace) return rest;
        input = rest; // continue cleaning
      }
      return Object.entries(input).reduce((acc, [key, value]) => {
        const cleanedValue = removeEmptyKeys(value);
        const isEmptyArray =
          Array.isArray(cleanedValue) && cleanedValue.length === 0;
        const isEmptyString =
          typeof cleanedValue === "string" && cleanedValue.trim() === "";
        const isNullOrUndefined =
          cleanedValue === null || cleanedValue === undefined;
        const isEmptyObject =
          cleanedValue &&
          typeof cleanedValue === "object" &&
          !Array.isArray(cleanedValue) &&
          Object.keys(cleanedValue).length === 0;

        if (
          isEmptyArray ||
          isEmptyString ||
          isNullOrUndefined ||
          isEmptyObject
        ) {
          return acc;
        }

        acc[key] = cleanedValue;
        return acc;
      }, {});
    }
  } catch (error) {
    logger.log(error);
  }

  return input;
};

export default removeEmptyKeys;